import { render, staticRenderFns } from "./CertificationAioLog.vue?vue&type=template&id=954b186e&scoped=true&"
import script from "./CertificationAioLog.vue?vue&type=script&lang=js&"
export * from "./CertificationAioLog.vue?vue&type=script&lang=js&"
import style0 from "./CertificationAioLog.vue?vue&type=style&index=0&id=954b186e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954b186e",
  null
  
)

export default component.exports